import React from "react";
import { TABLES } from "../constants";
import { getResult, pickProblem } from "../lib/multiplication";
import type { Feedback } from "../types";
import { useServiceWorker } from "./useServiceWorker";

export function usePracticeSession() {
  const [problem, setProblem] = React.useState(() => pickProblem(TABLES));
  const [answer, setAnswer] = React.useState("");
  const [feedback, setFeedback] = React.useState<Feedback>("idle");
  const [hintOpen, setHintOpen] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const result = getResult(problem);

  const serviceWorker = useServiceWorker();

  function focusAnswer() {
    window.setTimeout(() => inputRef.current?.focus(), 50);
  }

  function nextProblem() {
    setProblem((current) => pickProblem(TABLES, current));
    setAnswer("");
    setFeedback("idle");
    focusAnswer();
  }

  function submitAnswer(event: React.FormEvent) {
    event.preventDefault();

    if (Number(answer.trim()) === result) {
      setFeedback("correct");
      window.setTimeout(() => nextProblem(), 550);
      return;
    }

    setFeedback("wrong");
    setHintOpen(true);
  }

  function retryCurrentProblem() {
    setAnswer("");
    setFeedback("idle");
    focusAnswer();
  }

  return {
    answer,
    feedback,
    hintOpen,
    inputRef,
    problem,
    result,
    serviceWorker,
    nextProblem,
    retryCurrentProblem,
    setAnswer,
    setHintOpen,
    submitAnswer,
  };
}
